/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import LocalStorage from '../../utils/helpers/LocalStorage'

interface AuthState {
	signed: boolean
	token: string | null
	user:
		| {
				id: number
				name: string
				email: string
				curso_interesse_id?: number
				nome_curso_interesse?: string
				telephone?: string
				permissionId: number
				lastActive: string
				company: string
				companyId: number
				turma_id?: number
				calendar: boolean
				tag?: string
				show_modal_calendar: boolean
				show_modal_skill_mapping: boolean
				modo_curso_unico?: boolean
				white_label?: boolean
				link_skill_mapping?: string
				onboarding_all?: Array<{
					curso_id: number
					nivel_onboarding: number
					proficiencia_id: number
					updatedAt: string
				}>
				turmas?: Array<{
					id: number
					nome: string
					vagas: number
					vagas_disponiveis: any
					aulas_marcadas: any
					nivel_id: number
					professor_id: number
					createdAt: string
					updatedAt: string
					empresa_id: number
					curso_id: number
					status: string
					data_inicio: any
					ciclo_id: any
					dias_da_semana: any[]
				}>
		  }
		| undefined
	company:
		| {
				id: number
				nome: string
				gerente: string
				dominio: string
				funcionarios: number
				avatar: string
				logo: string
				modo_curso_unico: boolean
				white_label: boolean
				color_primary: string
				createdAt: string
				updatedAt: string
				slug: string
				deletedAt: any
		  }
		| undefined
}

const initialState: AuthState = {
	signed: false,
	token: null,
	user: undefined,
	company: undefined,
}

const storage = new LocalStorage()

export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		authenticate: (
			state,
			{ payload: { token } }: PayloadAction<{ token: string }>
		) => {
			storage.set('token', token)

			state.signed = true
			state.token = token
		},
		logout: (state) => {
			state.signed = false
			state.token = null

			storage.remove('token')
		},
		setUser: (
			state,
			{
				payload,
			}: PayloadAction<{
				id: number
				name: string
				email: string
				curso_interesse_id?: number
				nome_curso_interesse?: string
				telephone?: string
				permissionId: number
				lastActive: string
				company: string
				companyId: number
				turma_id?: number
				calendar: boolean
				show_modal_calendar: boolean
				show_modal_skill_mapping: boolean
				white_label?: boolean
				modo_curso_unico?: boolean
				onboarding_all?: Array<{
					curso_id: number
					nivel_onboarding: number
					proficiencia_id: number
					updatedAt: string
				}>
			}>
		) => {
			state.user = payload
		},
		setCompany: (
			state,
			{
				payload,
			}: PayloadAction<{
				id: number
				nome: string
				gerente: string
				dominio: string
				funcionarios: number
				logo: string
				avatar: string
				modo_curso_unico: boolean
				white_label: boolean
				color_primary: string
				createdAt: string
				updatedAt: string
				slug: string
				deletedAt: any
			}>
		) => {
			state.company = payload
		},
		resetAuthState: () => {
			return initialState
		},
	},
})

export const authCreators = authSlice.actions

export const authReducer = authSlice.reducer
